import React from "react";
import { NewMessageAction } from "../../../../components/messages/NewMessageAction";
import { NavigationItem } from "../../../../constants";
import {
  COACH_CLIENTS_ACTIVE_ROUTE,
  COACH_CLIENT_CALENDAR_ROUTE,
  COACH_CLIENT_NOTES_ROUTE,
  COACH_CLIENT_OVERVIEW_ROUTE,
  COACH_CLIENT_PR0GRAMS_ROUTE,
  COACH_CLIENT_ACTIVITY_ROUTE,
  COACH_CLIENT_SETTINGS_ROUTE,
  COACH_CLIENT_NUTRITION_ROUTE,
  COACH_CLIENT_EXERCISE_HISTORY_ROUTE,
} from "../../../routes";
import { HeaderButton } from "../../../../components/button/HeaderButton";
import NewChip from "../../../../components/chip/NewChip";

export const clientNavigation = (
  username: string,
  nutritionsEnabled: boolean,
): NavigationItem[] => [
  {
    name: "Overview",
    link: COACH_CLIENT_OVERVIEW_ROUTE.replace(":username", username),
  },

  {
    name: "Calendar",
    link: COACH_CLIENT_CALENDAR_ROUTE.replace(":username", username),
  },

  {
    name: "Activity",
    link: COACH_CLIENT_ACTIVITY_ROUTE.replace(":username", username),
  },
  {
    name: (
      <NewChip
        chipProps={{
          size: "small",
        }}
      >
        Exercises
      </NewChip>
    ),
    link: COACH_CLIENT_EXERCISE_HISTORY_ROUTE.replace(":username", username),
  },
  {
    name: "Programs",
    link: COACH_CLIENT_PR0GRAMS_ROUTE.replace(":username", username),
  },

  ...(nutritionsEnabled
    ? [
        {
          name: "Nutrition",
          link: COACH_CLIENT_NUTRITION_ROUTE.replace(":username", username),
        },
      ]
    : []),

  {
    name: "Notes",
    link: COACH_CLIENT_NOTES_ROUTE.replace(":username", username),
  },

  {
    name: "Settings",
    link: COACH_CLIENT_SETTINGS_ROUTE.replace(":username", username),
  },
];

export const clientsBreadcrumb: NavigationItem = {
  name: "Clients",
  link: COACH_CLIENTS_ACTIVE_ROUTE,
};

export const SendMessage = ({
  username,
  disabled,
}: {
  username: string;
  disabled?: boolean;
}) => (
  <NewMessageAction
    children="Send message"
    username={username}
    disabled={disabled}
    Button={HeaderButton}
  />
);
